export default __webpack_public_path__ + "static/media/topgu.21db2fc5.png";